import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {ThemesTable} from './table/ThemesTable'
import {ThemeEditModal} from './themes-edit-modal/ThemeEditModal'
import {KTCard} from '../../../../_dashboard/helpers'
import {ThemeListHeader} from './header/ThemeListHeader'
import { ToastContainer } from 'react-toastify'

const ThemesList = () => {
  const {itemIdForUpdate} = useListView()
  return (
    <>
      <KTCard>
      <ToastContainer />
        <ThemeListHeader />
        <ThemesTable />
      </KTCard>
      {itemIdForUpdate !== undefined && <ThemeEditModal />}
    </>
  )
}

const ThemesListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <ThemesList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {ThemesListWrapper}
